import isEmpty from 'lodash.isempty';

export const eventsPageViewProps = (eventPage, featureFlags) => {
  if (isEmpty(eventPage)) return {};

  const { longformSeoCopy, relatedVendors } = eventPage;

  return {
    hasSeoCopy: !!longformSeoCopy,
    relatedServices: relatedVendors && relatedVendors.map((relatedItem) => relatedItem.name),
    relatedServicesId: relatedVendors && relatedVendors.map((relatedItem) => relatedItem.id),
    ...featureFlags,
  };
};

export const eventsPageLevelBaseProps = (eventPage) => {
  if (isEmpty(eventPage)) return {};

  const { eventName } = eventPage;

  return {
    eventType: eventName,
  };
};
